import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { useReviewsContext } from "../context/reviews.context";
import { CreateReview } from "../createReview/createReview.container";
import { Reviews } from "../reviews/reviews.container";
import { ReviewsSummary } from "../reviewsSummary/reviewsSummary.container";

export const ProductReviewsComponent = () => {
    const { reviewsSummary } = useReviewsContext();

    if (isDefined(reviewsSummary) && reviewsSummary?.summary.count > 0) {
        return (
            <article
                className={cn(
                    "tw:flex tw:relative tw:flex-col tw:gap-12",
                    "tw:lg:flex-row"
                )}
            >
                <div
                    className={cn(
                        "tw:w-full",
                        "tw:lg:min-w-80 tw:lg:max-w-80 tw:lg:sticky tw:lg:top-0 tw:lg:left-0 tw:lg:h-fit"
                    )}
                >
                    <ReviewsSummary reviewsSummary={reviewsSummary} />
                </div>
                <div className={cn("tw:w-full")}>
                    <Reviews />
                </div>
            </article>
        );
    } else {
        return (
            <article>
                <CreateReview />
            </article>
        );
    }
};
